import {signKBTransactionJWT} from "../../Crypto/utils";
import {APIRequest} from "../../API/APIRequest";
import {createItemType} from "../../API/KB/KBAPI";
import {WebTools} from "../../constants";

export const splitArrays = (bigArray, size = 10) => {
    const splitArrays = [];

    for (let i = 0; i < bigArray.length; i += size) {
        splitArrays.push(bigArray.slice(i, i + size));
    }

    return splitArrays;
};

export const parseUrls = async (input, KB) => {
    input = input.trimStart();
    if (input.includes("<urlset>") || input.includes("<url>")) {
        // Assuming input is a part of sitemap.xml
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString("<root>" + input + "</root>", "text/xml");
        const urlElements = xmlDoc.getElementsByTagName("loc");

        const urls = Array.from(urlElements).map((urlElement) => urlElement.textContent);
        return { urls };
    } else {
        // Assuming input is whitespace-separated or newline-separated URLs
        const urls = input
            .split(/[\s\n]+/)
            .map((url) => url.trim())
            .filter((url) => url !== "");

        return { urls };
    }
};

export const extractPages = async (batch, KB) => {
    try {
        const transactionJWT = await signKBTransactionJWT({ toAccountId: WebTools["readWebpages"]?.accountId, ...KB })
        const response = await APIRequest('post', WebTools["readWebpages"]?.url, batch.map(o => {
            return { ...o, parsePrice: true }
        }), {
            headers: {
                'Content-Type': 'application/json',
                'transaction-jwt': transactionJWT
            }
        });

        return response?.data;
    } catch (e) {
        return null;
    }
};

export const readSitemap = async (sitemapURL, KB) => {
    const transactionJWT = await signKBTransactionJWT({ toAccountId: WebTools["readWebpage"]?.accountId, ...KB });
    let allSites = [];
    let lastEvaluatedIndex = 0;

    while (lastEvaluatedIndex !== null) {
        const response = await APIRequest('post', 'https://webtools.openkbs.com/readSitemap',
            { url: sitemapURL.trim(), lastEvaluatedIndex },
            {
                headers: {
                    'Content-Type': 'application/json',
                    'transaction-jwt': transactionJWT
                }
            }
        );

        const data = response?.data;
        if (data?.sites) {
            allSites = allSites.concat(data.sites);
            lastEvaluatedIndex = data.lastEvaluatedIndex;
        } else {
            lastEvaluatedIndex = null;
        }
    }

    return { sites: allSites };
}

export const readRobots = async (websiteUrl, KB) => {
    const transactionJWT = await signKBTransactionJWT({ toAccountId: WebTools["readWebpages"]?.accountId, ...KB })
    const response = await APIRequest('post', WebTools["readWebpages"]?.url,
        [{ url: websiteUrl.trim() + '/robots.txt', rawHTML: true }],
        {
            headers: {
                'Content-Type': 'application/json',
                'transaction-jwt': transactionJWT
            }
        }
    );

    return response?.data;
}

export const createPageType = async (embeddingTemplate) => {
    return await createItemType("page", [
        {
            "attrName": "url",
            "attrType": "itemId",
            "label": "Url",
            "placeholder": "Enter page url",
            "encrypted": false,
        },
        {
            "attrName": "title",
            "attrType": "keyword1",
            "label": "Title",
            "placeholder": "Enter page title",
            "encrypted": true,
        },
        {
            "attrName": "description",
            "attrType": "text1",
            "label": "Description",
            "placeholder": "Enter page description",
            "encrypted": true,
        },
        {
            "attrName": "content",
            "attrType": "text2",
            "label": "Content",
            "placeholder": "Enter page content",
            "encrypted": true,
        },
        {
            "attrName": "image",
            "attrType": "keyword2",
            "label": "Image",
            "placeholder": "Enter page image",
            "encrypted": true,
        },
        {
            "attrName": "price",
            "attrType": "float1",
            "label": "Price",
            "placeholder": "Enter page price",
            "encrypted": false,
        },
        {
            "attrName": "currency",
            "attrType": "keyword3",
            "label": "Currency",
            "placeholder": "Enter page currency",
            "encrypted": false,
        }
    ], embeddingTemplate)
}